import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import axios from 'axios'
import { Alert } from 'react-bootstrap'
import FormContainer from '../components/FormContainer.js'
import Loader from '../components/Loader.js'
import { API_URL } from '../apiUrl.js'

const VerifyOwnerEmailScreen = () => {
  const location = useLocation()
  const registrationSubmitted = location.state?.registrationSubmitted
  const [status, setStatus] = useState({
    loading: true,
    message: '',
    variant: 'danger'
  })

  useEffect(() => {
    const token = window.location.hash.slice(1)
    window.history.replaceState(
      null,
      '',
      `${window.location.pathname}${window.location.search}`
    )

    if (!token) {
      if (registrationSubmitted) {
        setStatus({
          loading: false,
          message:
            'If registration can proceed, a verification email will be sent. Check your inbox for the verification link.',
          variant: 'info'
        })
        return
      }

      setStatus({
        loading: false,
        message: 'This verification link is invalid or has expired.',
        variant: 'danger'
      })
      return
    }

    let active = true
    axios
      .post(`${API_URL}/owners/verify-email`, { token })
      .then(({ data }) => {
        if (active) {
          setStatus({
            loading: false,
            message: data.message,
            variant: 'success'
          })
        }
      })
      .catch((error) => {
        if (active) {
          setStatus({
            loading: false,
            message:
              error.response?.data?.message ||
              'Email verification failed. Please request a new link.',
            variant: 'danger'
          })
        }
      })

    return () => {
      active = false
    }
  }, [registrationSubmitted])

  return (
    <FormContainer>
      <h1>{registrationSubmitted ? 'Check your email' : 'Verify email'}</h1>
      {status.loading ?
        <Loader />
      : <Alert variant={status.variant}>{status.message}</Alert>}
      {!status.loading && (
        <Link to='/owner/login' className='btn btn-outline-primary'>
          Continue to owner sign in
        </Link>
      )}
    </FormContainer>
  )
}

export default VerifyOwnerEmailScreen
